<!-- eslint-disable -->
<template lang="pug">
		.settings(v-if='settings')
				template
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_shutterMode') }}:
								| {{ shutterMode }}
						br
						template(v-if="settings.mode === 'wordColumn'")
								template(v-if='settings.selectedGroups.length')
										span(v-if='settings.selectedGroups.length')
												| {{ $i18n.t('trainer.trainer_gameFormSetting_groups') }}:
												| {{ settings.selectedGroups.join('; ') }}
										br
								span
										| {{ amountOfItemsString }}:
										| {{ settings.amountOfItemsInColumn }}
								br
						template(v-if="settings.mode === 'text' && settings.sourceText")
								span
										| {{ $i18n.t('trainer.trainer_gameFormSetting_textIsSelected') }}
								br
								template(v-if='settings.textLabel')
										span
												| {{ $i18n.t('trainer.trainer_gameFormSetting_textLabel') }}: {{ settings.textLabel }}
										br
								span
										| {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfWordsInColumn') }}:
										| {{ settings.amountOfWordsInRow }}
								br
						template(v-if='settings.selectedGroups.length !== 0')
								span
										| {{ $i18n.t('trainer.trainer_gameFormSetting_groups') }}:
										| {{ settings.selectedGroups.join('; ') }}
								br
								div(v-for='(group, index) in lettersForGroups', :key='index')
										span
												| {{ group.name }}:
												| {{ group.letters.join('; ') }}
										br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_shutterSpeed') }}:
								| {{ settings.shutterSpeed.value }}
								| {{ $i18n.t('trainer.trainer_gameFormSettingValue_wordsPerMinute') }}
						br
						span
								| {{ invertedItemsString }}:
								span(v-if='settings.invertedWords')
										| {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
								span(v-else)
										| {{ $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_shutterSpeedIncrease') }}:
								span(v-if='settings.shutterSpeedIncrease')
										| {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
								span(v-else)
										| {{ $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
								span(v-if='settings.shutterSpeedIncrease')
										| {{ $i18n.t('trainer.trainer_gameFormSetting_maxSpeed') }}:
										| {{ settings.shutterMaxSpeed.value }}
										| {{ $i18n.t('trainer.trainer_gameFormSettingValue_wordsPerMinute') }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_metronome') }}:
								| {{ formattedBPM }}
				br
				slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";
    import {cloneDeep} from "lodash";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        },
        mounted() {
            if (!this.game.parameters.default['Группа 1 (ма, ро)'] && this.game.parameters.default['группа1МаРо']) {
                this.$set(this.game.parameters.default, 'Группа 1 (ма, ро)', cloneDeep(this.game.parameters.default['группа1МаРо']));
            }
            if (!this.game.parameters.default['Группа 2 (мя, ки)'] && this.game.parameters.default['группа2МяКи']) {
                this.$set(this.game.parameters.default, 'Группа 2 (мя, ки)', cloneDeep(this.game.parameters.default['группа2МяКи']));
            }
            if (!this.game.parameters.default['Группа 3 (ам, ор)'] && this.game.parameters.default['группа3АмОр']) {
                this.$set(this.game.parameters.default, 'Группа 3 (ам, ор)', cloneDeep(this.game.parameters.default['группа3АмОр']));
            }
            if (!this.game.parameters.default['Группа 4 (ям, ер)'] && this.game.parameters.default['группа4ЯмЕр']) {
                this.$set(this.game.parameters.default, 'Группа 4 (ям, ер)', cloneDeep(this.game.parameters.default['группа4ЯмЕр']));
            }
        },
        computed: {
            shutterMode () {
                switch (this.settings.mode) {
                    case ("wordColumn"):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeWordColumn');
                    case ("syllableColumn"):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeSyllableColumn');
                    case ("text"):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeText');
                }
            },
            amountOfItemsString () {
                return this.settings.mode === 'wordColumn'
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWordsInColumn')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_amountOfSyllablesInColumn');
            },
            invertedItemsString () {
                return this.settings.mode === 'syllableColumn'
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_invertedSyllables')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_invertedWords');
            },
            formattedBPM () {
                return this.settings.metronomeSpeed
                    ? `${this.settings.metronomeSpeed} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_bpm')
                    : this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated');
            },
            lettersForGroups() {
                let newArray = [];
                let groupsWithLettersSetting = ['Группа 1 (ма, ро)', 'Группа 2 (мя, ки)', 'Группа 3 (ам, ор)', 'Группа 4 (ям, ер)'];
                groupsWithLettersSetting.forEach(key => {
                    if (this.game.parameters.default[key] && this.game.parameters.default.selectedGroups.find(item => item.includes(key))) {
                        newArray.push({
                            name: key,
                            letters: this.game.parameters.default[key],
                        });
                    }
                });
                this.game.parameters.default.lettersForGroups = newArray;
                return newArray;
            },
        }
    }
</script>
